module.exports = __webpack_public_path__ + "img/parks-1-4.763138b0.jpg";